import { render, staticRenderFns } from "./PharBasedForm.vue?vue&type=template&id=a51ee450&scoped=true"
import script from "./PharBasedForm.vue?vue&type=script&lang=js"
export * from "./PharBasedForm.vue?vue&type=script&lang=js"
import style0 from "./PharBasedForm.vue?vue&type=style&index=0&id=a51ee450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51ee450",
  null
  
)

export default component.exports